import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, catchError, throwError } from 'rxjs';

export const AppInterceptor: HttpInterceptorFn = (req: any, next: any) => {
  const router = inject(Router);

  const userDetails = localStorage.getItem('user_details');
  let tokenData: any = null;

  if (userDetails) {
    try {
      tokenData = JSON.parse(userDetails);
    } catch {
      tokenData = null;
    }
  }

  const urlPath = router.url;
  const hasAdminRoute = urlPath.includes('admin');
  const isRefreshRequest = req.url.includes('/auth/refresh');

  if (!tokenData && hasAdminRoute && !isRefreshRequest) {
    router.navigate(['/web/home']);
    return EMPTY;
  }

  // Refresh uses its refresh-token body. Do not attach an expiring access token to it.
  const authRequest = tokenData && !isRefreshRequest
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${tokenData?.token ?? tokenData?.userDetail?.token}`,
          userId: `${tokenData?.userDetail?.userID}`,
          userName: `${tokenData?.userDetail?.userName}`,
        },
      })
    : req.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });

  return next(authRequest).pipe(
    catchError((err) => {
      if (err.status === 401 && !isRefreshRequest) {
        localStorage.clear();
        router.navigate(['/web/home']);
      }
      return throwError(() => err);
    })
  );
};
